export function parseAgentOrigin(url: string): string | undefined {
    try {
        return new URL(url).origin;
    } catch (e) {
        console.error("[AgentChat] Invalid agent URL:", url, e);
        return undefined;
    }
}
